import { Component } from 'react'
import { Container, Row, Col } from 'reactstrap'
import withApolloClient from '../../withApolloClient'
import RestrictedSection from "../../Components/RestrictedSection"

import TPAConfigList from './TPAConfigList'
import TPAConfigAction from './TPAConfigAction'
import TPAConfigListHeader from './TPAConfigListHeader'


const tableHeaders = [
    { id: "date_added", name: "Date Added", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "date_modified", name: "Date Modified", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "tpa", name: "TPA", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "lineOfBusiness", name: "Line Of Business", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "claimType", name: "Claim Type", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "communicationChannel", name: "Communication Channel", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "startDate", name: "Start Date", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "endDate", name: "End Date", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "branches", name: "Branches", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
]
const getDefaultColumnConfig = () => tableHeaders.map((column, index) => ({ ...column, order: index }))

class TPAConfigurationListContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            orderBy: ["-date_added"],
            filterValues: {},
            refetchTPAConfigList: false,
            columnConfig: getDefaultColumnConfig(),
        }
    }
    setColumnConfig = (columnConfig) => this.setState({ columnConfig })

    updateOrder = (string) => {
        let order = this.state.orderBy ? [...this.state.orderBy] : []
        let index = order.indexOf(string)
        if (index > -1) {
            order[index] = "-" + string
        } else {
            index = order.indexOf("-" + string)
            index > -1 ? order.splice(index, 1) : order.unshift(string)
        }
        this.setState({ orderBy: order })
    };


    render() {
        return (
            <RestrictedSection requiredPermission="view_tpaconfig">
                <Container fluid className="bos-listing-container">
                    <Row>
                        <Col xs={8}>
                            <TPAConfigListHeader
                                filterValues={this.state.filterValues}
                                setFilterValues={(filterValues) => this.setState({ filterValues })}
                                defaultFilters={this.state.filterValues}
                                {...this.props}
                            />
                        </Col>
                        <Col xs={4}>
                            <TPAConfigAction
                                columnConfig={this.state.columnConfig}
                                setColumnConfig={this.setColumnConfig}
                                tableId="tpaconfig"
                                defaultColumnConfig={getDefaultColumnConfig()}
                                refetchQuery={() => this.setState({ refetchTPAConfigList: !this.state.refetchTPAConfigList })}
                                {...this.props}
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col sm="12">
                            <TPAConfigList
                                columnConfig={this.state.columnConfig}
                                key={String(this.state.refetchTPAConfigList)}
                                currentUser={this.props.currentUser}
                                lineOfBusiness={this.state.filterValues.lineOfBusiness}
                                communicationChannel={this.state.filterValues.communicationChannel}
                                claimType={this.state.filterValues.claimType}
                                tpaName={this.state.filterValues.tpaName}
                                searchTerm={this.state.filterValues && this.state.filterValues.searchTerm ? this.state.filterValues.searchTerm : null}
                                orderBy={this.state.orderBy}
                                updateOrder={this.updateOrder}
                            />
                        </Col>
                    </Row>
                </Container>
            </RestrictedSection>
        )
    }
}



export default withApolloClient(
    TPAConfigurationListContainer
)
